module.exports = __webpack_public_path__ + "img/gamifinnopoly_white.a416c2d4.png";